import { Component, Input, makeStateKey, OnInit, TransferState } from '@angular/core';
import { SvgIconRegistryService } from 'angular-svg-icon';

@Component({
  selector: 'app-svg',
  templateUrl: './svg.component.html',
  styleUrls: ['./svg.component.scss']
})
export class SvgComponent implements OnInit {
  @Input() src: string = "";
  @Input() customClass: string = "";
  @Input() label: string = "Fahes";
  @Input() stretch: boolean = false;
  @Input() width: string = "90";
  @Input() height: string = "";
  @Input() fill: string = "";
  @Input() stroke: string = "";
  @Input() viewBox: string = "";

  constructor(
    private iconRegistry: SvgIconRegistryService,
    private transferState: TransferState
  ) { }

  ngOnInit() {
    if (this.src) {
      const stateKey = makeStateKey<string>(this.src); // Unique key for each icon
      if (this.transferState.hasKey(stateKey)) this.iconRegistry.addSvg(this.src, this.transferState.get(stateKey, ''));
    }
  }


}
